/**
* Action constants should be kept in one file. It allows new and existing developers
* to see all possible NGRX actions in the entire application just by looking at this file.
*/
// APPLICATION *************************
// Global State Reset
export const _CLEAR = 'CLEAR';

// Global Data Initialization Toggle
export const DATA_INIT    = 'DATA_INIT';
export const OA_DATA_INIT = 'OA_DATA_INIT';

// Main View
export const SET_MAIN_VIEW = 'SET_MAIN_VIEW';

// Login
export const SET_LOGIN_VIEW = 'SET_LOGIN_VIEW';

// Lost Password
export const SET_LOST_PASSWORD_VIEW = 'SET_LOST_PASSWORD_VIEW';

// Registration
export const SET_REGISTER_VIEW = 'SET_REGISTER_VIEW';

// SCRAP *******************************
export const CREATE_SCRAP = 'CREATE_SCRAP';
export const CREATE_SCRAPS = 'CREATE_SCRAPS';
export const DELETE_SCRAP = 'DELETE_SCRAP';
export const UPDATE_SCRAP = 'UPDATE_SCRAP';
export const UPDATE_SCRAPS = 'UPDATE_SCRAPS';
export const GET_SCRAP    = 'GET_SCRAP';
export const GET_ACTIVE_SCRAPS = 'GET_ACTIVE_SCRAPS';
export const GET_SCRAPS   = 'GET_SCRAPS';

// SYSTEM SETTINGS *********************
export const CREATE_SETTING = 'CREATE_SETTING';
export const DELETE_SETTING = 'DELETE_SETTING';
export const GET_SETTINGS   = 'GET_SETTINGS';
export const UPDATE_SETTING = 'UPDATE_SETTING';

export const GET_NEXT_BUSINESS_DAY = 'GET_NEXT_BUSINESS_DAY';
export const SET_SETTING_LIST_VIEW = 'SET_SETTING_LIST_VIEW';

export const NEXT_BUSINESS_DAY        = 'NEXT_BUSINESS_DAY';
export const SHIPMENT_ALLOW_DOWNGRADE = 'SHIPMENT_ALLOW_DOWNGRADE';
export const PRINTING_PRINT_DIELINE_SHEET = 'PRINTING_PRINT_DIELINE_SHEET';

// REPORTSS *********************
export const SET_REPORT_LIST_VIEW = 'SET_REPORT_LIST_VIEW';

// NOTIFICATIONS ***********************
// Tasks
export const ADD_TASK    = 'ADD_TASK';
export const CLEAR_TASKS = 'CLEAR_TASKS';
export const EDIT_TASK   = 'EDIT_TASK';
export const REMOVE_TASK = 'REMOVE_TASK';

// BINS ********************************
// Bins List
export const CLEAR_BIN  = 'CLEAR_BIN';
export const GET_BINS   = 'GET_BINS';
export const UPDATE_BIN = 'UPDATE_BIN';

// QA BINS ********************************
// QA Bins List
export const CLEAR_HOLDBIN  = 'CLEAR_HOLDBIN';
export const GET_HOLDBINS   = 'GET_HOLDBINS';
export const UPDATE_HOLDBIN = 'UPDATE_HOLDBIN';
export const CREATE_HOLDBIN = 'CREATE_HOLDBIN';

// Bins View
export const SET_BINS_VIEW = 'SET_BINS_VIEW';

//QA Bins View
export const SET_HOLDBINS_VIEW = 'SET_HOLDBINS_VIEW';

// EOD *********************************
// EOD History
export const CREATE_EOD      = 'CREATE_EOD';
export const CREATE_EODS     = 'CREATE_EODS';
export const CREATE_OA_EOD   = 'CREATE_OA_EOD';
export const DELETE_EOD      = 'DELETE_EOD';
export const DELETE_OA_EOD   = 'DELETE_OA_EOD';
export const UPDATE_EOD      = 'UPDATE_EOD';
export const UPDATE_EODS     = 'UPDATE_EODS';
export const UPDATE_OA_EOD   = 'UPDATE_OA_EOD';
export const GET_EOD_HISTORY = 'GET_EOD_HISTORY';
export const GET_LAST_EOD_RAN_TODAY = 'GET_LAST_EOD_RAN_TODAY';

export const SET_EOD_HISTORY_VIEW = 'SET_EOD_HISTORY_VIEW';

// HOLD ********************************
// Hold Amounts
export const GET_HOLD_AMOUNTS = 'GET_HOLD_AMOUNTS';

// Hold List View
export const SET_HOLD_LIST_VIEW = 'SET_HOLD_LIST_VIEW';

// IMPOSITION TEMPLATES ****************
// Imposition Templates View
export const RESET_TEMPLATE_OVERLAY = 'RESET_TEMPLATE_OVERLAY';
export const SET_TEMPLATE_OVERLAY   = 'SET_TEMPLATE_OVERLAY';
export const SET_TEMPLATE_LIST_VIEW = 'SET_TEMPLATE_LIST_VIEW';

// Imposition Templates List
export const CREATE_TEMPLATE = 'CREATE_TEMPLATE';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const GET_TEMPLATES   = 'GET_TEMPLATES';
export const RENAME_TEMPLATE = 'RENAME_TEMPLATE';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';

// Imposition Template Edit Form
export const RESET_TEMPLATE_EDIT_FORM    = 'RESET_EDIT_FORM';
export const SET_TEMPLATE_EDIT_FORM      = 'SET_TEMPLATE_EDIT_FORM';
export const RESET_TEMPLATE_EDIT_OVERLAY = 'RESET_TEMPLATE_EDIT_OVERLAY';
export const SET_TEMPLATE_EDIT_OVERLAY   = 'SET_TEMPLATE_EDIT_OVERLAY';

// Template Overlays
export const SET_TEMPLATE_OVERLAY_VIEW = 'SET_TEMPLATE_OVERLAY_VIEW';

// Template PDFs
export const CREATE_TEMPLATE_PDF = 'CREATE_TEMPLATE_PDF';
export const DELETE_TEMPLATE_PDF = 'DELETE_TEMPLATE_PDF';
export const GET_TEMPLATE_PDFS   = 'GET_TEMPLATE_PDFS';

// ONLINE AISLE =====================================================
export const GET_OA_AMOUNTS = 'GET_OA_AMOUNTS';

// Dashboard Amounts
export const GET_OA_JOB_AMOUNTS = 'GET_OA_JOB_AMOUNTS';

// Die List
export const CREATE_DIE = 'CREATE_DIE';
export const DELETE_DIE = 'DELETE_DIE';
export const GET_DIES = 'GET_DIES';
export const SET_DIE_LIST_VIEW = 'SET_DIE_LIST_VIEW';
export const UPDATE_DIE = 'UPDATE_DIE';

// Horizon List
export const CREATE_HORIZON = 'CREATE_HORIZON';
export const DELETE_HORIZON = 'DELETE_HORIZON';
export const GET_HORIZONS = 'GET_HORIZONS';
export const UPDATE_HORIZON = 'UPDATE_HORIZON';

// Horizons Stats List
export const CREATE_HORIZON_STAT = 'CREATE_HORIZON_STAT';
export const DELETE_HORIZON_STAT = 'DELETE_HORIZON_STAT';
export const GET_HORIZON_STATS = 'GET_HORIZON_STATS';
export const UPDATE_HORIZON_STAT = 'UPDATE_HORIZON_STAT';

// Job List
export const CREATE_OA_JOB  = 'CREATE_OA_JOB';
export const CREATE_OA_JOBS = 'CREATE_OA_JOBS';
export const DELETE_OA_JOB  = 'DELETE_OA_JOB';
export const GET_OA_JOBS    = 'GET_OA_JOBS';
export const UPDATE_OA_JOB  = 'UPDATE_OA_JOB';

// ORDERS ******************************
// Order List
export const CREATE_OA_ORDER = 'CREATE_OA_ORDER';
export const DELETE_OA_ORDER = 'DELETE_OA_ORDER';
export const GET_OA_ORDERS   = 'GET_OA_ORDERS';
export const UPDATE_OA_ORDER = 'UPDATE_OA_ORDER';
export const GET_AMAZON_ORDERS = 'GET_AMAZON_ORDERS';
export const GET_MARKETPLACE_ORDERS = 'GET_MARKETPLACE_ORDERS';
export const GET_PTO_ORDERS = 'GET_PTO_ORDERS';
export const UPDATE_PTO_ORDER = 'UPDATE_PTO_ORDER';


// SHIPMENTS ***************************
export const CREATE_OA_SHIPMENT  = 'CREATE_OA_SHIPMENT';
export const DELETE_OA_SHIPMENT  = 'DELETE_OA_SHIPMENT';
export const UPDATE_OA_SHIPMENT  = 'UPDATE_OA_SHIPMENT';
export const UPDATE_OA_SHIPMENTS = 'UPDATE_OA_SHIPMENTS';
export const GET_OA_SHIPMENTS    = 'GET_OA_SHIPMENTS';

// Yellow Bags
export const CREATE_OA_YELLOWBAG = 'CREATE_OA_YELLOWBAG';
export const DELETE_OA_YELLOWBAG = 'DELETE_OA_YELLOWBAG';
export const GET_OA_YELLOWBAGS   = 'GET_OA_YELLOWBAGS';
export const UPDATE_OA_YELLOWBAG = 'UPDATE_OA_YELLOWBAG';

// BINS ********************************
// Bins List
export const CLEAR_OA_BIN     = 'CLEAR_BIN';
export const GET_OA_BINS      = 'GET_BINS';
export const UPDATE_OA_BIN    = 'UPDATE_BIN';
export const SET_OA_BINS_VIEW = 'SET_OA_BINS_VIEW';

// BATCHES *****************************
// Batch Amounts
export const GET_OA_BATCH_AMOUNTS = 'GET_OA_BATCH_AMOUNTS';
export const GET_FORMATTED_BATCHES = 'GET_FORMATTED_BATCHES';

// Batch List
export const CREATE_OA_BATCH          = 'CREATE_OA_BATCH';
export const DELETE_OA_BATCH          = 'DELETE_OA_BATCH';
export const GET_OA_BATCHES           = 'GET_OA_BATCHES';
export const UPDATE_OA_BATCH          = 'UPDATE_OA_BATCH';
export const GET_SORTED_OA_BATCHES    = 'GET_SORTED_OA_BATCHES';
export const GET_PTO_BATCHES          = 'GET_PTO_BATCHES';
export const GET_PTO_PREPRINT_BATCHES = 'GET_PTO_PREPRINT_BATCHES';
export const GET_PTO_PRINTING_BATCHES = 'GET_PTO_PRINTING_BATCHES';
export const GET_PTO_SEALED_PRINTING_BATCHES = 'GET_PTO_SEALED_PRINTING_BATCHES';

// HOLD ********************************
// Hold Amounts
export const GET_OA_HOLD_AMOUNTS = 'GET_OA_HOLD_AMOUNTS';

// SHEETS ===========================================================

// BATCHES *****************************
// Batch Amounts
export const GET_BATCH_AMOUNTS = 'GET_BATCH_AMOUNTS';

// Batch Details View
export const SET_BATCH_DETAILS_VIEW = 'SET_BATCH_DETAILS_VIEW';

// Batch List
export const CREATE_BATCH = 'CREATE_BATCH';
export const CREATE_BATCHES = 'CREATE_BATCHES';
export const DELETE_BATCH = 'DELETE_BATCH';
export const GET_BATCH_HISTORY = 'GET_BATCH_HISTORY';
export const GET_BATCHES  = 'GET_BATCHES';
export const UPDATE_BATCH = 'UPDATE_BATCH';

// Batch List View
export const SET_BATCH_LIST_VIEW = 'SET_BATCH_LIST_VIEW';

// ORDERS ******************************
// Order List
export const CREATE_ORDER        = 'CREATE_ORDER';
export const DELETE_ORDER        = 'DELETE_ORDER';
export const GET_ORDER           = 'GET_ORDER';
export const GET_ORDERS          = 'GET_ORDERS';
export const GET_FILTERED_ORDERS = 'GET_FILTERED_ORDERS';
export const UPDATE_ORDER        = 'UPDATE_ORDER';
export const UPDATE_ORDERS       = 'UPDATE_ORDERS';
export const SET_ORDER_LIST_VIEW = 'SET_ORDER_LIST_VIEW';

// Order Details
export const SET_ORDER_DETAILS_VIEW = 'SET_ORDER_DETAILS_VIEW';

// Mail Innovations
export const GET_MID_ORDERS = 'GET_MID_ORDERS';
export const UPDATE_MID_ORDER = 'UPDATE_MID_ORDER';

// PRINTERS ****************************
export const RESET_PRINTER_CONFIG_VIEW = 'RESET_PRINTER_CONFIG_VIEW';
export const SET_PRINTER_CONFIG_VIEW   = 'SET_PRINTER_CONFIG_VIEW';

// RTS *********************************
export const GET_RTS_TOTALS = 'GET_RTS_TOTALS';

// SCRAP *******************************
export const SET_SCRAP_REPORT_VIEW = 'SET_SCRAP_REPORT_VIEW';

// SHIPMENTS ***************************
// Shipment List
export const CREATE_SHIPMENT  = 'CREATE_SHIPMENT';
export const DELETE_SHIPMENT  = 'DELETE_SHIPMENT';
export const GET_SHIPMENT     = 'GET_SHIPMENT';
export const GET_FORMATTED_SHIPMENTS = 'GET_FORMATTED_SHIPMENTS';
export const GET_SHIPMENTS    = 'GET_SHIPMENTS';
export const SET_SELECTED_SHIPMENT = 'SET_SELECTED_SHIPMENT';
export const UPDATE_SHIPMENT  = 'UPDATE_SHIPMENT';
export const UPDATE_SHIPMENTS = 'UPDATE_SHIPMENTS';

// Shipment List View
export const SET_SHIPMENT_LIST_VIEW = 'SET_SHIPMENT_LIST_VIEW';

// Shipment Amounts by Status
export const GET_SHIPMENT_AMOUNTS = 'GET_SHIPMENT_AMOUNTS';

// Shipment Details
export const SET_SHIPMENT_DETAILS_VIEW = 'SET_SHIPMENT_DETAILS_VIEW';

// Shipment Estimates
export const CREATE_ESTIMATES = 'CREATE_ESTIMATES';
export const UPDATE_ESTIMATES = 'UPDATE_ESTIMATES';

// Package List
export const CREATE_PACKAGE_FORM = 'CREATE_PACKAGE_FORM';
export const UPDATE_PACKAGE_FORM = 'UPDATE_PACKAGE_FORM';

// Yellow Bags
export const CREATE_YELLOWBAG = 'CREATE_YELLOWBAG';
export const DELETE_YELLOWBAG = 'DELETE_YELLOWBAG';
export const GET_YELLOWBAGS   = 'GET_YELLOWBAGS';
export const GET_FORMATTED_YELLOWBAGS = 'GET_FORMATTED_YELLOWBAGS';
export const UPDATE_YELLOWBAG = 'UPDATE_YELLOWBAG';

// PRODUCTS ****************************
// Product List
export const CREATE_PRODUCT  = 'CREATE_PRODUCT';
export const DELETE_PRODUCT  = 'DELETE_PRODUCT';
export const GET_PRODUCT     = 'GET_PRODUCT';
export const GET_PRODUCTS    = 'GET_PRODUCTS';
export const UPDATE_PRODUCT  = 'UPDATE_PRODUCT';
export const UPDATE_PRODUCTS = 'UPDATE_PRODUCTS';

// Product List View
export const SET_PRODUCT_LIST_VIEW = 'SET_PRODUCT_LIST_VIEW';

// Product Details View
export const RESET_PRODUCT_DETAILS_VIEW = 'RESET_PRODUCT_DETAILS_VIEW';
export const SET_PRODUCT_DETAILS_VIEW   = 'SET_PRODUCT_DETAILS_VIEW';

// Product Sub-assembly List
export const GET_SUBASSEMBLIES  = 'GET_SUBASSEMBLIES';
export const CREATE_SUBASSEMBLY = 'CREATE_SUBASSEMBLY';
export const DELETE_SUBASSEMBLY = 'DELETE_SUBASSEMBLY';
export const UPDATE_SUBASSEMBLY = 'UPDATE_SUBASSEMBLY';

// JOBS *********************************
// Dashboard Amounts
export const GET_DASHBOARD_AMOUNTS = 'GET_DASHBOARD_AMOUNTS';

// Job Amounts
export const GET_JOB_AMOUNTS = 'GET_JOB_AMOUNTS';

// Job Details View
export const SET_JOB_DETAILS_VIEW = 'SET_JOB_DETAILS_VIEW';

// Job List
export const CREATE_JOB  = 'CREATE_JOB';
export const CREATE_JOBS = 'CREATE_JOBS';
export const DELETE_JOB  = 'DELETE_JOB';
export const DELETE_QUEUED_MTS_JOB = 'DELETE_QUEUED_MTS_JOB';
export const GET_JOBS    = 'GET_JOBS';
export const GET_QUEUED_MTS_JOBS = 'GET_QUEUED_MTS_JOBS';
export const SET_GHS_LIST = 'SET_GHS_LIST';
export const SET_STICKER_LIST = 'SET_STICKER_LIST';
export const UPDATE_JOB  = 'UPDATE_JOB';
export const UPDATE_JOBS = 'UPDATE_JOBS';

// Job List View
export const SET_JOB_LIST_VIEW = 'SET_JOB_LIST_VIEW';

//Job Update To Shipment Flag View
export const SET_JOB_SHIP_FLAG = 'SET_JOB_SHIP_FLAG';

// USERS ********************************
export const SET_USER_LIST_VIEW = 'SET_USER_LIST_VIEW';

export const CREATE_USER = 'CREATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const GET_USERS   = 'GET_USERS';
export const UPDATE_USER = 'UPDATE_USER';

// Comments Map
export const GET_COMMENT_MAP        = 'GET_COMMENT_MAP';
export const SET_COMMENT_ORDERS_MAP = 'SET_COMMENT_ORDERS_MAP';
export const SET_COMMENT_JOBS_MAP   = 'SET_COMMENT_JOBS_MAP';
export const SET_COMMENT_SHIPMENT_MAP = 'SET_COMMENT_SHIPMENT_MAP';

// Job Location
export const CREATE_JOB_LOCATION = 'CREATE_JOB_LOCATION';
export const GET_JOB_LOCATIONS   = 'GET_JOB_LOCATIONS';

// Role List
export const CREATE_ROLE = 'CREATE_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';
export const GET_ROLES = 'GET_ROLES';
export const UPDATE_ROLE = 'UPDATE_ROLE';

export const SET_ROLE_VIEW = 'SET_ROLE_VIEW';

// LASER PRESTA MATERIAL CONFIG
export const GET_LASER_PRESTA_MATERIAL_CONFIG = 'GET_LASER_PRESTA_MATERIAL_CONFIG';
export const UPDATE_LASER_PRESTA_MATERIAL_CONFIG = 'UPDATE_LASER_PRESTA_MATERIAL_CONFIG';
export const CREATE_LASER_PRESTA_MATERIAL_CONFIG = 'CREATE_LASER_PRESTA_MATERIAL_CONFIG';
export const DELETE_LASER_PRESTA_MATERIAL_CONFIG = 'DELETE_LASER_PRESTA_MATERIAL_CONFIG';


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/actions.ts